export default __webpack_public_path__ + "static/media/empty1.145f9f1e.jpg";